import { Stack } from '@servicetitan/design-system';
import { BasicCard, ComboboxCard } from './demo/auto-v2';
import { SelectCard } from './demo/auto-v2-selects';
import { withAnvil } from './test/data';
import './styles.css';

export default {
    title: 'Skeleton/styles anvil2',
    parameters: {},
    decorators: [withAnvil],
};

export const AutoStyles = () => (
    <Stack direction="column" spacing={2}>
        <BasicCard />
        <BasicCard className="skeleton-auto" />
    </Stack>
);

export const AutoComboStyles = () => (
    <Stack direction="column" spacing={2}>
        <ComboboxCard />
        <ComboboxCard className="skeleton-auto" />
    </Stack>
);

export const AutoSelectStyles = () => (
    <Stack direction="column" spacing={2}>
        <SelectCard />
        <SelectCard className="skeleton-auto" />
    </Stack>
);
